"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// this is used to generate a options list for the mat-select -> mat-option
const vessel_category_types_1 = require("../../../model/enum/vessel-category-types");
exports.CategoryType2LabelMapping = {
    [vessel_category_types_1.Category.PONTOON]: 'Pontoon',
    [vessel_category_types_1.Category.FISHING_BOAT]: 'Fishing boat',
    [vessel_category_types_1.Category.DECK_BOAT]: 'Deck boat',
    [vessel_category_types_1.Category.HOUSEBOAT]: 'Houseboat',
    [vessel_category_types_1.Category.CATAMARAN]: 'Catamaran',
    [vessel_category_types_1.Category.YACHT]: 'Yacht',
    [vessel_category_types_1.Category.SPEED_BOAT]: 'Speed boat',
    [vessel_category_types_1.Category.BOW_RIDER]: 'Bow rider',
    [vessel_category_types_1.Category.MEGA_YACHT]: 'Mega yacht',
    [vessel_category_types_1.Category.SUPER_YACHT]: 'Super yacht',
    [vessel_category_types_1.Category.CENTER_CONSOLE]: 'Center console',
    [vessel_category_types_1.Category.SPORT_YACHT]: 'Sport yacht',
    [vessel_category_types_1.Category.CUSTOM_BOAT]: 'Custom boat',
    [vessel_category_types_1.Category.SAILBOAT]: 'Sailboat',
};
